<section class="container space">
  <h1>Προαπαιτούμενα</h1>
  <div class="career">
    <section class="flex-container container align-left wrap">
      <section class="get-to-know-us">
        <h2>
          Τι χρειάζεσαι για να ξεκίνησεις με το Mastering Angular Bootcamp;
        </h2>
        <p>
          Τα προαπαιτούμενα της συμμετοχής σε αυτό το πρόγραμμα σπουδών είναι τα
          εξής:
        </p>
        <ul>
          <li>- Κατοχή Η/Υ και σύνδεση Internet</li>
          <li>- Βασική γνώση Αγγλικής γλώσσας</li>
          <li>- {{ programmingKnowledge }}</li>
          <li>- {{ studyHours }}</li>
        </ul>
        <p>{{ programDuration }}</p>
      </section>
      <div class="img-container">
        <picture>
          <img
            src="assets/images/prerequisites/prerequisites2.jpg"
            class="responsive-img"
            width="320"
            height="203"
            style="width: initial; height: initial"
            alt="Support in next steps"
          />
        </picture>
      </div>
    </section>

    <section id="no-gap" class="flex-container container">
      <div class="img-container">
        <picture>
          <source
            type="image/webp"
            media="(min-width: 768px) and (max-width: 1139px)"
            srcset="assets/images/home/dont_waste_time_320.webp"
          />
          <source
            type="image/webp"
            media="(min-width: 768px) and (max-width: 1139px)"
            srcset="assets/images/home/dont_waste_time_320.png"
          />
          <source
            type="image/webp"
            media="(min-width: 1140px)"
            srcset="assets/images/home/dont_waste_time_450.webp"
          />
          <source
            type="image/webp"
            media="(min-width: 1140px)"
            srcset="assets/images/home/dont_waste_time_450.png"
          />
          <img
            src="assets/images/home/dont_waste_time_320.png"
            class="responsive-img"
            width="320"
            height="203"
            style="width: initial; height: initial"
            alt="Don't waste time"
          />
        </picture>
      </div>
      <section class="get-to-know-us">
        <h2>
          Ενημερώσου δωρεάν και πάρε την απόφαση που θα απογειώσει την καριέρα
          σου!
        </h2>
        <p>
          Οι επιτυχημένοι απόφοιτοι της Ακαδημίας μας, η μεθοδικότητα και υψηλή
          κατάρτιση των καθηγητών μας και η πλούσια εμπειρία μας, αποτελούν τα
          εχέγγυα της επιτυχίας μας!
        </p>
        <p>
          Ανακάλυψε τον ταχύτερο και πιο αποτελεσματικό τρόπο για να αποκτήσεις
          job-ready εμπειρία.
        </p>
        <button
          class="primary-btn"
          (click)="applyModalService.onOpen()"
          aria-label="Express interest"
        >
          Ενημερώσου Δωρεάν
        </button>
      </section>
    </section>
  </div>
</section>
